// TODO: remove this once we finish releasing the enforcement
export const EXPIRED_SUBSCRIPTION_ENFORCEMENT_RELEASE_DATE = new Date(
  '2022-09-27T17:00:00Z' // 10AM PT September 27th 2022
);
// TODO: remove this after the release of enforcement for disabled subscription
export const DISABLED_SUBSCRIPTION_ENFORCEMENT_RELEASE_DATE = new Date(
  '2022-10-04T17:00:00Z' // 10AM PT October 4th 2022
);
// we start showing nudge bar when their expiration is within 14 days from today
